// extracted by mini-css-extract-plugin
module.exports = {"emptyStateWrap":"_2yMadCNPUyE6Nv3zU9rS5P","icon":"KRJohnucVjpQ4gXxUD6F2","text":"_1K6PIByTZxv7m5RA3zOkeC"};